module.exports = __webpack_public_path__ + "img/delay_5.37f20b8c.svg";